module.exports = __webpack_public_path__ + "sarch_logo.png?aff85ee04992b24bcfdbb94039a77978";